import { render, staticRenderFns } from "./BizHeadquartersLifeReport.vue?vue&type=template&id=5fdd1f82&"
import script from "./BizHeadquartersLifeReport.vue?vue&type=script&lang=js&"
export * from "./BizHeadquartersLifeReport.vue?vue&type=script&lang=js&"
import style0 from "./BizHeadquartersLifeReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports